module.exports = __webpack_public_path__ + "img/ar-white.607f18a6.svg";